import { Injectable } from '@angular/core';
import { CanActivateChild, Router } from '@angular/router';
import { fromSubscription } from '@app/subscription/store';
import { Store } from '@ngrx/store';
import { filter, map, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PurchaseGuard implements CanActivateChild {
  constructor(private router: Router, private store: Store) {}

  canActivateChild() {
    return this.store.select(fromSubscription.selectIsSubscriptionLoaded).pipe(
      filter((loaded) => loaded),
      switchMap(() =>
        this.store.select(fromSubscription.selectCanUpgrade).pipe(
          map((canUpgrade) => {
            if (!canUpgrade) {
              return this.router.parseUrl('/');
            }
            return canUpgrade;
          })
        )
      )
    );
  }
}
